<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5 px-5 lg:px-10 py-10">
          <div class="w-full h-full py-5 flex flex-col gap-5">
            <div class="flex justify-between">
              <h2 class="text-xl font-semibold" >
                Total Students -
                <span >{{ count_list ||0 }}</span>
               
              </h2>
              <router-link :to="{ name: 'HodDashboards' }">
                <button class="bg-blues text-white py-1 px-3 rounded-lg">
                  Back
                </button>
              </router-link>
            </div>
            <div class="flex">
              <form
                @submit.prevent="searchUserValue"
                class="flex w-full md:w-auto"
              >
                <input
                  type="text"
                  placeholder="Search here"
                  v-model="searching"
                  @input="searchUserValue"
                  class="px-4 py-2 rounded-l-md border border-gray-300 focus:outline-none"
                />
                <button class="bg-blues text-white px-4 py-2 rounded-r-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </form>
            </div>

            <div class="flex justify-between">
              <h1 class="text-lg font-semibold dark_text">Student List </h1>
            </div>
            <form
              @submit.prevent="filterData"
              class="flex flex-col lg:flex-row flex-wrap gap-4"
            >
              <select
                name="semester"
                id="semester"
                v-model="selectsemester"
                class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Semester</option>

                <option value="I">I</option>
                <option value="II">II</option>
                <option value="III">III</option>
                <option value="IV">IV</option>
                <option value="V">V</option>
                <option value="VI">VI</option>
              </select>

              <select
                name="course"
                id="course"
                v-model="selectPatch"
                class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Batch</option>
                <option
                  v-for="batch in batchs"
                  :key="batch.year"
                  :value="batch.year"
                >
                  {{ batch.year }}
                </option>
              </select>
              <select
                name="section"
                id="section"
                v-model="selectprogram"
                @change="departmentget(selectprogram)"
                class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Program</option>
                <option
                  v-for="program in programs"
                  :key="program.name"
                  :value="program.name"
                >
                  {{ program.name }}
                </option>
              </select>
              <select
                name="subject_code"
                id="subject_code"
                v-model="selectdepartment"
                class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Department</option>
                <option
                  v-for="department in departments"
                  :key="department.name"
                  :value="department.name"
                >
                  {{ department.name }}
                </option>
              </select>

              <select
                name="session"
                id="session"
                v-model="selectsession"
                class="hidden bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Session</option>
              </select>
              <select
                name="Section"
                id="Section"
                v-model="selectsection"
                class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Section</option>
                <option
                  v-for="section in sections"
                  :key="section.name"
                  :value="section.name"
                >
                  {{ section.name }}
                </option>
              </select>
              <select
                name="practical"
                id="practical"
                v-model="selectpractical"
                class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Practical</option>
                <option
                  v-for="practical in practicals"
                  :key="practical.name"
                  :value="practical.name"
                >
                  {{ practical.name }}
                </option>
              </select>
              <select
                name="Section"
                id="Section"
                v-model="selectelective"
                class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled selected>Elective</option>
                <option
                  v-for="elective in electives"
                  :key="elective.name"
                  :value="elective.name"
                >
                  {{ elective.name }}
                </option>
              </select>

              <div class="flex items-center gap-3">
                <button
                  type="submit"
                  class="bg-blue-600 text-white rounded-md px-4 py-2 text-xs font-semibold uppercase hover:bg-blue-700 transition"
                >
                  Submit
                </button>
                <button
                  type="button"
                  @click="clearFilters"
                  class="text-blue-600 underline flex items-center text-xs font-semibold gap-1"
                >
                  <img
                    src="@/assets/attendance/cancel.webp"
                    alt="Clear"
                    class="w-3 h-3 object-contain"
                  />
                  Clear All
                </button>
              </div>
            </form>

            <!-- filter applied values  -->
            <div
              v-if="filtered"
              class="flex flex-col gap-3 lg:flex-row flex-wrap w-full px-2 py-3 bg-primary1 dark_text text-sm border rounded-md mt-3"
            >
              <div>Filter Applied :</div>
              <div v-if="this.selectsemester.length > 0" class="flex gap-3">
                <h3>Smester :</h3>
                <p>{{ this.selectsemester }}</p>
                <p>||</p>
              </div>
              <div v-if="this.selectPatch.length > 0" class="flex gap-3">
                <h3>Batch :</h3>
                <p>{{ this.selectPatch }}</p>
                <p>||</p>
              </div>
              <div v-if="this.selectprogram.length > 0" class="flex gap-3">
                <h3>Programs :</h3>
                <p>{{ this.selectprogram }}</p>
                <p>||</p>
              </div>
              <div v-if="this.selectdepartment.length > 0" class="flex gap-3">
                <h3>Department :</h3>
                <p>{{ this.selectdepartment }}</p>
                <p>||</p>
              </div>
              <div v-if="this.selectsection.length > 0" class="flex gap-3">
                <h3>Section :</h3>
                <p>{{ this.selectsection }}</p>
                <p>||</p>
              </div>
              <div v-if="this.selectpractical.length > 0" class="flex gap-3">
                <h3>Practical :</h3>
                <p>{{ this.selectpractical }}</p>
                <p>||</p>
              </div>
              <div v-if="this.selectelective.length > 0" class="flex gap-3">
                <h3>Elective :</h3>
                <p>{{ this.selectelective }}</p>
                <p>||</p>
              </div>
            </div>

            <div class="w-full overflow-scroll">
              <table class="min-w-full">
                <thead>
                  <tr
                    class="text-left bg-blues text whitespace-nowrap text-sm"
                  >
                    <th class="px-6 py-3">S.No</th>
                    <th class="px-6 py-3">Student Info</th>
                    <th class="px-6 py-3">Batch</th>
                    <th class="px-6 py-3">Department</th>
                    <th class="px-6 py-3">Section</th>
                    <th class="px-6 py-3">Semester</th>
                    <th class="px-6 py-3">Program</th>
                    <th class="px-6 py-3">Elective</th>
                    <th class="px-6 py-3">Practical</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
                  <tr class="w-full">
                    <td colspan="12" class="text-center py-6">
                      <div class="flex items-center justify-center">
                        <img src="@/assets/attendance/loading.gif" alt="" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <template v-if="student_list.length > 0">
                    <tr
                      v-for="(list, index) in student_list"
                      :key="index"
                      class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
                    >
                      <td class="px-6 py-3">
                        {{ (currentPage - 1) * perPage + index + 1 }}
                      </td>
                      <td class="px-6 py-3">
                        <p class="font-semibold capitalize">
                          <span v-if="list.user_name">{{
                            list.user_name
                          }}</span>
                          <span v-else>---</span>
                        </p>
                        <p
                          class="text-xs text-gray-600 font-medium font-sans flex items-center"
                        >
                          <img
                            src="@/assets/attendance/mail.svg"
                            alt=""
                            srcset=""
                            class="w-3 h-3 mr-1"
                          />
                          : {{ list.email }}
                          <span class="m-1">|</span>
                          <img
                            src="@/assets/attendance/phone.svg"
                            alt=""
                            srcset=""
                            class="w-3 h-3 mr-1"
                          />
                          : <span v-if="list.mobile">{{ list.mobile }}</span>
                          <span v-else>None</span>
                        </p>
                        <p class="text-xs text-gray-600 font-medium font-sans">
                          Enroll no :None<span class="m-1">|</span> USN :
                          <span v-if="list.usn">{{ list.usn }}</span>
                          <span v-else>None</span>
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.batch != null">{{
                          list.batch.split("__").slice(0, -1).join("__")
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.department != null">{{
                          list.department
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.section != null">{{
                          list.section
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.semester != null">{{
                          list.semester.split("__").pop()
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.program != null">{{
                          list.program
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.elective != null">{{
                          list.elective
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.practical != null">{{
                          list.practical
                        }}</span
                        ><span v-else>---</span>
                      </td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="11" class="px-6 py-3 text-center">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
                <!-- <tfoot>
                  <tr>
                    <td colspan="11" class="p-6 bg-[#18469d]"></td>
                  </tr>
                </tfoot> -->
                <!-- pagination -->
                <tfoot v-if="totalPages > 1" class="">
                  <tr>
                    <td colspan="9" class="bg-blues">
                      <div class="flex justify-center py-4 space-x-2">
                        
                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage === 1"
                          @click="prevPage"
                        >
                          &laquo;
                        </button>
                        <!-- {{ currentPage%pageSize }} {{ currentPage }} -->
                        <button
                          v-for="page in visiblePages"
                          :key="page"
                          class="px-3 py-2 rounded"
                          :class="{
                            'bg-blue-800 text-white': currentPage === page,
                            'bg-white border border-gray-400 text-gray-800':
                              currentPage !== page,
                          }"
                          @click="changePage(page)"
                        >
                          {{ page }}
                        </button>

                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage >= totalPages"
                          @click="nextPage"
                        >
                          &raquo;
                        </button>


                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Hod/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      student_list: [],
      //   loading: true,
      messages: {
        text: "",
        type: "null",
      },
      selectsemester: "",
      selectPatch: "",
      selectdepartment: "",
      selectprogram: "",
      selectsession: "",
      selectsection: "",
      selectpractical: "",
      selectelective: "",
      departments: [],
      batchs: [],
      programs: [],
      sections: [],
      practicals: [],
      electives: [],
      count_list: "",
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      searching: "",
      filtered: false,
      pageSize: 5,
      pageArray: []
    };
  },
  components: {
    SideBar,
    FlashMessage,
  },
  async created() {
    await this.getstudent(1);
    await this.programget();
    await this.batchget();
    await this.sectionget();
    await this.practicalget();
    await this.electiveget();
  },

  mounted(){
    // setTimeout(()=>{
    //   for(let i=1; i<this.totalPages+1; i++){
    //     this.pageArray.push(i);
    //   }
    // }, 300)
   
  },

  computed: {
    ...mapGetters(["userInfo"]),

    visiblePages() {
      const start = Math.floor((this.currentPage - 1) / this.pageSize) * this.pageSize;
      const end = Math.min(start + this.pageSize, this.totalPages);
      return this.pageArray.slice(start, end);
    }

  //   paginationRange() {
  //     const totalPages = this.totalPages;
  //     const currentPage = this.currentPage;
  //     let pages = [];

  //     if (totalPages <= 5) {
  //       pages = [...Array(totalPages).keys()].map((x) => x + 1);
  //     } else {
  //       if (currentPage > 3) pages.push(1);
  //       if (currentPage > 4) pages.push("...");

  //       const startPage = Math.max(2, currentPage - 1);
  //       const endPage = Math.min(totalPages - 1, currentPage + 1);

  //       for (let i = startPage; i <= endPage; i++) {
  //         pages.push(i);
  //       }

  //       if (currentPage < totalPages - 3) pages.push("...");
  //       if (currentPage < totalPages - 2) pages.push(totalPages);
  //     }

  //     return pages;
  //   },
  },

  watch: {
    student_list () {
      for (let i = 1; i < this.totalPages + 1; i++) {
        this.pageArray.push(i);
      }
      // this.setPages();
    }
  },

  methods: {
    async programget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.programs = res.data.data;
            console.log("  this.programs", this.programs);
          }
        });
    },
    async batchget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.batchs = res.data.data;
            console.log("  this.batch", this.batch);
          }
        });
    },
    async departmentget(program) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__name=${program}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.departments = res.data.data;
            console.log("  this.department", this.department);
          }
        });
    },
    async sectionget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.sections = res.data.data;
            console.log("  this.sections", this.sections);
          }
        });
    },
    async practicalget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/practical-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.practicals = res.data.data;
            console.log("  this.sections", this.sections);
          }
        });
    },
    async electiveget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/elective-get/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.electives = res.data.data.data;
            console.log("  this.electives", this.electives);
          }
        });
    },
    async getstudent(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-profile-details-get/?Key=${this.userInfo.token_key}&page=${page}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.student_list = res.data.data.data;
            this.count_list = res.data.total;
            console.log("  this.count_list", this.count_list);
            this.totalPages = res.data.total_page;
          }
        });
    },
    async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-profile-details-get/?search=${this.searching}&Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.student_list = res.data.data.data;
            this.count_list = res.data.total;
            console.log("  this.student_list", this.student_list);
            this.totalPages = res.data.total_pages;
          }
        });
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getstudent(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getstudent(this.currentPage);
      }
    },

    changePage(page) {

      this.currentPage = page;
      this.getstudent(page);

      // this.totalPages = this.currentPage / this.totalPages;

      // if (page !== "..." && page !== this.currentPage) {
        
      // }
    },
    // filterData() {
    //   const formatQueryParam = (key, values) => {
    //     if (!values || values.length === 0) return "";
    //     return Array.isArray(values)
    //       ? values
    //           .map((value) => `${key}=${encodeURIComponent(value)}`)
    //           .join("&")
    //       : `${key}=${encodeURIComponent(values)}`;
    //   };
    //   const queryParams = [
    //     `Key=${encodeURIComponent(this.userInfo.token_key)}`,
    //     formatQueryParam("sales_team", this.selectsemester),
    //     formatQueryParam("batch__year", this.selectPatch),
    //     formatQueryParam("utm_source", this.selectdepartment),
    //     formatQueryParam("program__name", this.selectprogram),
    //     formatQueryParam("state", this.selectsection),
    //   ]
    //     .filter((param) => param !== "")
    //     .join("&");

    //   const apiUrl = `${process.env.VUE_APP_API}/student-profile-details-get/?${queryParams}`;
    //   axios.get(apiUrl).then((res) => {
    //     if (res.data.data.status == 200) {
    //       this.filtered = true;
    //       this.student_list = res.data.data.data;
    //       console.log("  this.student_list", this.student_list);
    //       this.totalPages = Math.ceil(res.data.total / this.perPage);
    //     }
    //   });
    // },
    filterData() {
      const urlBase = `${process.env.VUE_APP_API}/student-profile-details-get/?Key=${this.userInfo.token_key}&page=${this.currentPage}`;
      const params = new URLSearchParams();

      if (this.selectsemester)
        params.append("semester__semester", this.selectsemester);
      if (this.selectPatch) params.append("batch__year", this.selectPatch);
      if (this.selectdepartment)
        params.append("department__name", this.selectdepartment);
      if (this.selectprogram)
        params.append("program__name", this.selectprogram);
      if (this.selectsection) {
        params.append("section__name", this.selectsection);
      }
      if (this.selectpractical) {
        params.append("practical__name", this.selectpractical);
      }
        if (this.selectelective) {
        params.append("elective__name", this.selectelective);
      }
      const queryString = params.toString();
      if (!queryString) return;

      const separator = urlBase.includes("?") ? "&" : "?";
      const url = `${urlBase}${separator}${queryString}`;

      axios
        .get(url)
        .then((res) => {
          if (res.data.data.status == 200) {
            this.filtered = true;
            this.student_list = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = res.data.total_page;
          } else {
            this.student_list = null;
            console.log("No data or invalid response");
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    clearFilters() {
      this.filtered = false;
      this.getstudent(this.currentPage);
      this.selectsemester = "";
      this.selectPatch = "";
      this.selectdepartment = "";
      this.selectprogram = "";
      this.selectsection = "";
      this.selectpractical = "";
      this.selectelective="";
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
